import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-info-news',
  templateUrl: './info-news.component.html',
  styleUrls: ['./info-news.component.scss']
})
export class InfoNewsComponent {

  Data: any = [];

  newsSubscription: Subscription = null;

  public result_message = ""
  constructor(private systemSiteService: SystemSiteService, private router: Router,  private http: HttpClient) { }



  ngOnInit() {


    this.LoadData();




  }


  LoadData() {
    this.newsSubscription = this.systemSiteService.get_news().subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.Data = data.result_data;

      },
      error: (error) => { console.log(error) },
    })
  }


  public load_image(url: string) {

    return this.http.get(url, { responseType: 'blob' });
  }



  ngOnDestroy(): void {
    if (this.newsSubscription)
      this.newsSubscription.unsubscribe();

  }

}